import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VentanaMinimizable } from 'src/app/utils/ventana-minimizable.util';

export interface HelpItem {
    term: string;
    description: string;
    icon?: string;
    iconColor?: string;
}

export interface HelpDialogData {
    title: string;
    items: HelpItem[];
    /** Abierto como ventana flotante minimizable (sin backdrop). */
    flotante?: boolean;
}

@Component({
    selector: 'app-help-dialog',
    templateUrl: './help-dialog.component.html',
    styleUrls: ['./help-dialog.component.scss']
})
export class HelpDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<HelpDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: HelpDialogData
    ) {
        this.ventana = new VentanaMinimizable(this.dialogRef, !!this.data?.flotante, '450px');
    }

    /** Minimizar/restaurar cuando se abre como ventana flotante (data.flotante). */
    ventana: VentanaMinimizable;

    close(): void {
        this.dialogRef.close();
    }
}
